var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card-text',{staticClass:"generate-jig-modal__loading"},[_c('div',{staticClass:"loading-animation"},[_c('div',{ref:"lottieContainer",staticClass:"loading-animation__lottie"}),_c('p',{staticClass:"loading-animation__text"},[_vm._v(_vm._s(_vm.loadingPercentage)+"% "+_vm._s(_vm.loadingMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }